<div class="selector-objetivos-registro">
  <button
    type="button"
    class="selector-objetivos-registro-trigger"
    [id]="triggerId"
    [disabled]="isDisabled"
    [attr.aria-label]="placeholder">
    <span class="selector-objetivos-registro-texto" [class.es-placeholder]="!textoSeleccion()">
      {{ textoSeleccion() || placeholder }}
    </span>
    <ion-icon name="chevron-down-outline" aria-hidden="true"></ion-icon>
  </button>

  <ion-popover
    class="select-popover select-popover-medium"
    [trigger]="triggerId"
    [dismissOnSelect]="false"
    side="bottom"
    alignment="start">
    <ng-template>
      <ion-content>
        <ion-list lines="full" class="selector-objetivos-registro-lista">
          <ion-item
            *ngFor="let obj of objetivosVisita"
            button
            detail="false"
            [class.opcion-deshabilitada]="opcionDeshabilitada(obj.id_objetivo_visita)"
            (click)="onOpcionClick(obj.id_objetivo_visita, $event)">
            <ion-checkbox
              slot="start"
              [checked]="estaSeleccionado(obj.id_objetivo_visita)"
              [disabled]="opcionDeshabilitada(obj.id_objetivo_visita)"
              (click)="$event.stopPropagation()"
              (ionChange)="onToggle(obj.id_objetivo_visita, $event)">
            </ion-checkbox>
            <ion-label>{{ obj.descripcion }}</ion-label>
          </ion-item>
        </ion-list>
      </ion-content>
    </ng-template>
  </ion-popover>
</div>
